import { IDeleteServicoProdutoUseCase } from "../../../presentation/useCases/delete/delete_servico_produto_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * DeleteServicoProdutoUseCase
 */

export class DeleteServicoProdutoUseCase implements IDeleteServicoProdutoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async deleteServicoProduto(
    idProdutoServico: number,
  ): Promise<void> {
    await this.repository.deleteServicoProduto(
      idProdutoServico,
    );
  }
}
